import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

function UploadCalendar({ onClose }) {
  const [icsFile, setIcsFile] = useState(null);
  const [message, setMessage] = useState("");
  const { state } = useLocation();
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (state && state.message) {
      setMessage(state.message);
    }
  }, [state]);

  const isValidFileType = (filename) => /\.(ics)$/i.test(filename);

  const handleFileChange = (event) => {
    setTouched(true);
    const selectedFile = event.target.files[0];
    if (selectedFile && isValidFileType(selectedFile.name)) {
      setIcsFile(selectedFile);
      setMessage("");
    } else {
      setIcsFile(null);
      setMessage("Invalid file type. Please select an ICS file.");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!icsFile) {
      setMessage("Please select an ICS file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", icsFile);
    formData.append("type", icsFile.type);

    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("No authentication token found. Please log in again.");
      return;
    }

    try {
      await axios.post("https://genz-staging.feeltiptop.com/api/upload_calendar", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setMessage("ICS file uploaded successfully!");
    } catch (error) {
      console.error("Error uploading file:", error);
      setMessage(
        error.response?.data?.error || "An unexpected error occurred.",
      );
    }
  };

  const messageClass = message.includes("successfully")
    ? "text-green-600"
    : "text-red-500";

  return (
    <div className="flex">
      <div className="relative w-[550px] rounded-2xl bg-white p-4 shadow-xl">
        <button
          onClick={onClose}
          className="absolute right-5 top-5 rounded-lg px-3 py-2 text-right font-semibold shadow-sm"
        >
          X
        </button>
        {/* Title */}
        <div className="mb-6">
          <h2 className="text-left text-xl font-normal text-gray-900">
            Upload Calendar
          </h2>
          <p className="text-normal mt-1 text-left text-gray-500">
            Only ICS files are allowed.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="m-0">
          {/* Upload area */}
          <div className="flex justify-center">
            <label
              htmlFor="calendar-upload"
              className="flex w-full max-w-md cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 py-2 text-center"
            >
              <img
                src="/Featured icon.svg"
                alt="Upload Icon"
                className="mb-3 h-10 w-10"
              />
              <span className="text-sm">
                <span className="text-blue-600 hover:underline">
                  Click to upload
                </span>{" "}
                or drag and drop
              </span>
              <span className="mt-1 text-xs text-gray-400">
                ICS only (max. XX MB)
              </span>
              <input
                id="calendar-upload"
                type="file"
                onChange={handleFileChange}
                className="hidden"
                accept=".ics"
              />
            </label>
          </div>

          {/* File feedback */}
          {touched && !icsFile && (
            <p className="mt-2 text-center text-sm text-red-500">
              ❌ No valid file attached yet
            </p>
          )}
          {icsFile && (
            <p className="mt-2 text-center text-sm text-green-700">
              ✅ File attached:{" "}
              <span className="font-medium">{icsFile.name}</span>
            </p>
          )}

          {/* Upload Button */}
          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              className="rounded-2xl bg-blue-500 px-4 py-1 font-semibold text-white transition hover:bg-blue-700"
            >
              Upload
            </button>
          </div>
        </form>

        {/* Feedback Messages */}
        {message && (
          <p className={`mt-4 text-center text-sm ${messageClass}`}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
}

export default UploadCalendar;
